import * as St from './Design.styles';

import DesignSidePanel from '~organisms/DesignSidePanel';

type DesignProps = React.PropsWithChildren<{
  isSidePanelExpanded?: boolean;
}>;

const Design = ({ children, isSidePanelExpanded = true }: DesignProps) => (
  <St.Container>
    <St.DrawingAreaContainer>{children}</St.DrawingAreaContainer>
    <DesignSidePanel isExpanded={isSidePanelExpanded} />
  </St.Container>
);

export default Design;
